import React from 'react';
import ChatMessage, { ChatMessageData } from './ChatMessage';
import './chat-messages-list.scss';

export interface ChatDayGroup {
  date: string;
  messages: ChatMessageData[];
}

interface ChatMessagesListProps {
  chatMessagesList: ChatDayGroup[];
  currentUserId: string;
  canStartVideoChat: boolean;
  onStartVideoChat: (message: ChatMessageData) => void;
}

const ChatMessagesList = ({
  chatMessagesList,
  currentUserId,
  canStartVideoChat,
  onStartVideoChat,
}: ChatMessagesListProps) => {
  if (!chatMessagesList || chatMessagesList.length === 0) {
    return null;
  }

  return (
    <div className="chat-messages-list">
      {chatMessagesList.map((dayGroup: ChatDayGroup, dayIndex: number) => (
        <React.Fragment key={dayIndex}>
          <div className="date-divider">
            <div className="divider-text" role="presentation">
              {dayGroup.date}
            </div>
          </div>
          {dayGroup.messages.map(
            (message: ChatMessageData, messageIndex: number) => (
              <ChatMessage
                key={messageIndex}
                message={message}
                currentUserId={currentUserId}
                canStartVideoChat={canStartVideoChat}
                onStartVideoChat={onStartVideoChat}
              />
            )
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ChatMessagesList;